import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class Piping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diameters: '',
      avgLength: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAvgLength = this.handleChange.bind(null, 'avgLength');
    this.handleChangeDiameters = this.handleChange.bind(null, 'diameters');
  }
  handleChange(key, value) {
    const {
      onCalc
    } = this.props;
    this.setState({
      [key]: value
    }, () => {
      const {
        diameters,
        avgLength
      } = this.state;
      if (diameters !== '' && avgLength !== '') {
        // Calculate the surface area
        const total = 3.14 * diameters * avgLength * 1.2;
        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const {
      diameters,
      avgLength
    } = this.state;
    const {
      result
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "3.14 x Total Diameters x Avg Pipe Length x 1.2 = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Total All Pipe Diameters",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDiameters,
      value: diameters
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Avg Length of Each Pipe",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAvgLength,
      value: avgLength
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
Piping.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};
Piping.defaultProps = {
  onCalc: null,
  result: null
};